<header class="flex header">
  <h2>
    {{
      addSubcategories
        ? ('Fabric_Category_Add_Subcategory' | translateWF: 'Add Subcategory')
        : category?.id
          ? ('Fabric_Category_Edit' | translateWF: 'Edit Category')
          : ('Fabric_Category_Create' | translateWF: 'Create Category')
    }}
  </h2>
  <p-button type="button" icon="pi pi-times" (click)="onClose()" [disabled]="isLoading" />
</header>
@if (isLoading) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}
<section class="content">
  @if (!createCategory) {
    <h6 class="subtitle under__line mb-[1rem] uppercase">
      @if (category?.parentCode) {
        {{ category?.parentCode }}
        <i class="pi pi-angle-right" style="font-size: 1rem"></i>
        {{ category?.code }}
      } @else {
        {{ category?.code }}
      }
    </h6>
  }
  <div class="flex gap-[0.5rem] items-start">
    <i class="pi pi-language mt-[3px]"></i>
    {{ 'Common_Spanish_Translate' | translateWF: 'Spanish Translate' }}
    <p-toggleswitch [formControl]="spanishTranslate" />
  </div>
  <form [formGroup]="categoryFormGroup">
    <!-- name -->
    <div class="form-box" formGroupName="name">
      <label>{{
        category?.id && category?.level! > 1 ? ('Fabric_Category_Subcategory' | translateWF: 'Subcategory Name') : ('Fabric_Category_Category' | translateWF: 'Category Name')
      }}</label>

      <p-inputgroup>
        <p-inputgroup-addon> EN </p-inputgroup-addon>
        <input
          pInputText
          type="text"
          class="w-full"
          formControlName="en"
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && categoryFormGroup.get('name.en')?.invalid,
          }"
        />
      </p-inputgroup>
      @if (submittedForm && categoryFormGroup.get('name')?.invalid) {
        <div class="text-red-500 text-sm">
          <div *ngIf="categoryFormGroup.get('name')?.errors?.['required']">
            {{ 'Common_Field_Required' | translateWF: 'This field is required.' }}
          </div>
        </div>
      }
      @if (spanishTranslate.value) {
        <p-inputgroup class="mt-[1rem]">
          <p-inputgroup-addon> ES </p-inputgroup-addon>
          <input formControlName="es" pInputText type="text" class="w-full"
        /></p-inputgroup>
      }
    </div>
    @if (!category?.id && categoryType != 'Item') {
      <div class="form-box">
        <label>{{ 'Fabric_Category_Category_Code' | translateWF: 'Category Code' }}</label>
        <input
          pInputText
          type="text"
          class="w-full"
          formControlName="code"
          maxlength="3"
          minlength="3"
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && categoryFormGroup.get('code')?.invalid,
          }"
        />
        @if (submittedForm && categoryFormGroup.get('code')?.invalid) {
          <div class="text-red-500 text-sm">
            <div *ngIf="categoryFormGroup.get('code')?.errors?.['required']">
              {{ 'Common_Field_Required' | translateWF: 'This field is required.' }}
            </div>
            <div *ngIf="categoryFormGroup.get('code')?.errors?.['minlength']">
              {{ 'Fabric_Category_Required_Code_Msg' | translateWF: 'Code must have 3 characters.' }}
            </div>
          </div>
        }
      </div>
    }
    @if (categoryType === 'Item') {
      <div class="form-box">
        <label>{{
          category?.id && category?.level! > 1
            ? ('Fabric_Category_Subcategory_Description' | translateWF: 'Subcategory Description')
            : ('Fabric_Category_Category_Description' | translateWF: 'Category Description')
        }}</label>
        <textarea rows="2" cols="30" pTextarea class="w-full" formControlName="description"></textarea>
      </div>
    }
    @if (categoryType === 'Fabric') {
      <div class="form-box">
        <label>{{ 'Fabric_Category_Machine_Type' | translateWF: 'Machine Type' }}</label>
        <p-select
          formControlName="machineTypeReference"
          [options]="machineTypes"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'Common_Select' | translateWF: 'Select'"
          class="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && categoryFormGroup.get('machineTypeReference')?.invalid,
          }"
        />
        @if (submittedForm && categoryFormGroup.get('machineTypeReference')?.invalid) {
          <div class="text-red-500 text-sm">
            <div *ngIf="categoryFormGroup.get('machineTypeReference')?.errors?.['required']">
              {{ 'Common_Field_Required' | translateWF: 'This field is required.' }}
            </div>
          </div>
        }
      </div>
    }
    @if (category?.id && addSubcategories) {
      <h6 class="subtitle under__line mb-[1rem] uppercase">
        {{ 'Fabric_Category_Subcategories' | translateWF: 'Subcategories' }}
      </h6>
      <div class="flex gap-[0.5rem] items-start">
        <i class="pi pi-language mt-[3px]"></i>
        {{ 'Common_Spanish_Translate' | translateWF: 'Spanish Translate' }}
        <p-toggleswitch [formControl]="spanishTranslate" />
      </div>
      <div formArrayName="subcategories">
        <div *ngFor="let subcategory of subcategories.controls; let i = index" [formGroupName]="i">
          <!-- name -->
          <div class="form-box" formGroupName="name">
            <label>{{ 'Fabric_Category_Subcategory' | translateWF: 'Subcategory Name' }}</label>

            <p-inputgroup>
              <p-inputgroup-addon> EN </p-inputgroup-addon>
              <input
                pInputText
                type="text"
                class="w-full"
                formControlName="en"
                [ngClass]="{
                  'ng-invalid ng-dirty': submittedForm && subcategory.get('name.en')?.invalid,
                }"
              />
            </p-inputgroup>
            @if (submittedForm && subcategory.get('name.en')?.invalid) {
              <div class="text-red-500 text-sm">
                <div *ngIf="subcategory.get('name.en')?.errors?.['required']">
                  {{ 'Common_Field_Required' | translateWF: 'This field is required.' }}
                </div>
              </div>
            }
            @if (spanishTranslate.value) {
              <p-inputgroup class="mt-[1rem]">
                <p-inputgroup-addon> ES </p-inputgroup-addon>
                <input formControlName="es" pInputText type="text" class="w-full"
              /></p-inputgroup>
            }
          </div>
          @if (categoryType === 'Fiber') {
            <div class="form-box">
              <label>{{ 'Fabric_Category_Category_Code' | translateWF: 'Category Code' }}</label>
              <p-inputgroup>
                <p-inputgroup-addon>{{ category?.code }}-</p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  class="w-full"
                  formControlName="code"
                  maxlength="3"
                  minlength="3"
                  oninput="this.value = this.value.toUpperCase()"
                  [ngClass]="{
                    'ng-invalid ng-dirty': submittedForm && subcategory.get('code')?.invalid,
                  }"
                />
              </p-inputgroup>
              @if (submittedForm && subcategory.get('code')?.invalid) {
                <div class="text-red-500 text-sm">
                  <div *ngIf="subcategory.get('code')?.errors?.['required']">
                    {{ 'Common_Field_Required' | translateWF: 'This field is required.' }}
                  </div>
                  <div *ngIf="subcategory.get('code')?.errors?.['minlength']">
                    {{ 'Fabric_Category_Required_Code_Msg' | translateWF: 'Code must have 3 characters.' }}
                  </div>
                </div>
              }
            </div>
          }
          @if (this.categoryType === 'Item') {
            <div class="form-box">
              <label>{{ 'Fabric_Category_Subcategory_Description' | translateWF: 'Subcategory Description' }}</label>
              <textarea rows="2" cols="30" pTextarea class="w-full" formControlName="description"></textarea>
            </div>
          }
        </div>
      </div>
      @if (canEdit) {
        <p-button type="button" icon="pi pi-plus" variant="outlined" [label]="'Fabric_Category_Add_Subcategory' | translateWF: 'Add Subcategory'" (click)="addSubcategory()" />
      }
    }
  </form>
</section>
<footer>
  <p-button type="button" class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="isLoading || !canEdit" />
  <p-button type="button" class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" [disabled]="isLoading" />
</footer>
